import { Fragment, ReactElement, useMemo } from 'react';
import { useActionAuthorization } from 'shell/hooks/use-action-authorization';
import {
  AuthenticAuthorizations,
  CashCheckAuthorization,
  CertificationAuthorizations,
  ClaimsAuthorizations,
  RegisterCertificationAuthorizations,
  TypeDocAuthorizations,
  StatementsAuthorizations,
  HistoricalAuthorizations,
  ResidencyPermitAuthorizations,
  ReleaseModeAuthorizations,
  PrintReceiptPosAuthorizations,
  RegistrationIDCardAuthorizations,
  ReleaseIdCardAuthorizations,
  CashManagementAuthorizations,
  LotsManagementAuthorizations,
  ReprintCidAuthorizations,
  RetrieveIdCardAuthorizations,
  AmountAuthorizations,
  AnnullamentIDCardAuthorizations,
} from 'shell/authorizations/front-office';
import { DisabledTableServiceMenu } from 'shell/view-models/disabled-menu';
import ServiceTableCollapse from './service-table-collapse';
import { useUserProfile } from 'shell/hooks/use-user-profile';

interface NestedItemsFrontOfficeServiceTableProps {
  link: string;
  onSubItemClick?: () => void;
}

const NestedItemsFrontOfficeServiceTable = ({
  link,
  onSubItemClick,
}: NestedItemsFrontOfficeServiceTableProps): ReactElement => {
  const actions = useActionAuthorization({
    certificazione: CertificationAuthorizations,
    attestazione: ClaimsAuthorizations,
    autentiche: AuthenticAuthorizations,
    dichiarazioni: StatementsAuthorizations,
    storiche: HistoricalAuthorizations,
    controlloDiCassa: CashCheckAuthorization,
    ricercaRegistro: RegisterCertificationAuthorizations,
    tipoDoc: TypeDocAuthorizations,
    permessoDiSoggiorno: ResidencyPermitAuthorizations,
    modalitaRilascio: ReleaseModeAuthorizations,
    stampaRicevutPos: PrintReceiptPosAuthorizations,
    registrazioneCarta: RegistrationIDCardAuthorizations,
    annullamentoCarta: AnnullamentIDCardAuthorizations,
    rilascioCarta: ReleaseIdCardAuthorizations,
    leva: HistoricalAuthorizations,
    elettorale: HistoricalAuthorizations,
    ufficioCassa: CashManagementAuthorizations,
    gestioneLotti: LotsManagementAuthorizations,
    ristampaCid: ReprintCidAuthorizations,
    recuperoCartelliniCie: RetrieveIdCardAuthorizations,
    ricercaImporto: AmountAuthorizations,
  });

  const { userProfile } = useUserProfile();

  const gestioneTabelleSistema = userProfile.datiLogin?.profile?.feature?.sistema;

  const visibilityServiceTable = useMemo(() => {
    return (
      (!actions.tipoDoc && !actions.modalitaRilascio && !actions.ricercaRegistro) ||
      gestioneTabelleSistema === '0'
    );
  }, [actions, gestioneTabelleSistema]);

  return (
    <Fragment>
      {visibilityServiceTable ? undefined : (
        <ServiceTableCollapse
          link={link}
          onSubItemClick={onSubItemClick}
          active={(actions || {}) as DisabledTableServiceMenu}
        />
      )}
    </Fragment>
  );
};

NestedItemsFrontOfficeServiceTable.displayName =
  'nested Items front office service table component';

export default NestedItemsFrontOfficeServiceTable;
